// extracted by mini-css-extract-plugin
export default {"AddResourceHeader":"AddResourceHeader_AddResourceHeader__509hM","AddResourceHeader__Img":"AddResourceHeader_AddResourceHeader__Img__LLMYe"};